<div
  class="input-box"
  [ngClass]="{
    hasError: formControl?.invalid && formControl?.touched
  }"
  [matTooltip]="getErrorMessage(formControl)"
  matTooltipPosition="right"
  [matTooltipDisabled]="formControl?.valid || !formControl?.touched"
>
  <mat-form-field>
    <mat-label *ngIf="!formControl.value"
      >{{ placeholder
      }}<span *ngIf="required" class="required">*</span></mat-label
    >
    <input
      matInput
      [matDatepicker]="picker"
      [formControl]="formControl"
      (dateChange)="onChange($event)"
    />
    <mat-datepicker-toggle
      *ngIf="!hideToggle"
      matSuffix
      [for]="picker"
    ></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
